import { loginRequest, organizationRequest } from '../authConfig';
import { InteractionRequiredAuthError, BrowserAuthError } from "@azure/msal-browser";
import { callMsGraphOrg } from '../graph';
import axios from "axios";
import { encryptKey } from './common-encrypt-util';
import { clearLogoutInProgress } from './common-auth-utils';

const WEB_API_URL = process.env.REACT_APP_WEB_API_URL;

export async function loginToMicrosoft(instance) {

    try {
        clearLogoutInProgress();
        instance.NavigateToLoginRequestUrl = true;

        var response = instance.loginRedirect(loginRequest);
        if (response) {
            console.log(response);
        }
        else
            console.log("Failed to Log in again.")
    }
    catch (e) {
        console.log(`ERROR Logging In: ${e}`)
    }

}

export async function getUserOrganizationData(instance, isAuthenticated, accounts, orgData, setOrgData) {

    if (orgData != null) {
        return orgData;
    }

    if (!isAuthenticated || !accounts || accounts.length === 0) {
        await instance.loginRedirect(loginRequest);
        return null;
    }

    console.log(`getUserOrganizationData : ${accounts[0]}`)

    const request = {
        ...loginRequest, organizationRequest,
        account: accounts[0]
    };

    try {
        var response = await instance.acquireTokenSilent(request);
        if (response != null) {
            console.log(accounts[0])
            const orgSilent = await callMsGraphOrg(response.accessToken)
            if (orgSilent != null) {
                console.log(orgSilent);
                setOrgData(orgSilent);
                return orgSilent;
            }
        }
    }
    catch (e) {
        console.log("getUserOrganizationData.acquireTokenSilent failed");
        console.log(e);

        const message = e?.toString?.() || "";

        const shouldDoInteractiveAuth =
            e instanceof InteractionRequiredAuthError ||
            e instanceof BrowserAuthError ||
            message.includes("monitor_window_timeout") ||
            message.includes("interaction_required") ||
            message.includes("login_required") ||
            message.includes("AADSTS50058") ||
            message.includes("AADSTS160021");

        if (shouldDoInteractiveAuth) {
            await instance.acquireTokenRedirect(request);
            return null;
        }

        throw e;
    }
}


export async function tryGetUserOrganizationData(instance, isAuthenticated, accounts, orgData, setOrgData) {
    if (orgData != null) {
        return { data: orgData, error: null };
    }

    if (!isAuthenticated || !accounts || accounts.length === 0) {
        return { data: null, error: "not_authenticated" };
    }

    const request = {
        ...loginRequest,
        ...organizationRequest,
        account: accounts[0]
    };

    try {
        const response = await instance.acquireTokenSilent(request);

        if (response?.accessToken) {
            const orgSilent = await callMsGraphOrg(response.accessToken);

            if (orgSilent != null) {
                setOrgData(orgSilent);
                return { data: orgSilent, error: null };
            }
        }

        return { data: null, error: "no_data" };
    } catch (e) {
        console.log("tryGetUserOrganizationData.acquireTokenSilent failed");
        console.log(e);

        const message = e?.toString?.() || "";

        if (
            e instanceof InteractionRequiredAuthError ||
            e instanceof BrowserAuthError ||
            message.includes("admin consent") ||
            message.includes("AADSTS65001") ||
            message.includes("AADSTS90094") ||
            message.includes("consent") ||
            message.includes("permissions") ||
            message.includes("interaction_required") ||
            message.includes("login_required") ||
            message.includes("monitor_window_timeout")
        ) {
            return { data: null, error: "consent_or_interaction_required" };
        }

        if (message.includes("invalid_grant")) {
            return { data: null, error: "invalid_grant" };
        }

        return { data: null, error: message || "unknown_error" };
    }
}


export async function getAuditVaultUser(isAuthenticated, account) {

    if (isAuthenticated) {

        var rsaKey = await encryptKey(`{GraphId: "${account.localAccountId}" }`);
        if (rsaKey) {
            var result = await axios.get(`${WEB_API_URL}User/GetUserByGraphId`, {
                params: {
                    key: `${rsaKey}`
                }
            });

            if (result.data != null && result.data != "") {
                return result.data;
            }
            else {
                rsaKey = (`{GraphId: "${await encryptKey(account.localAccountId)}", AzureTenantId: "${await encryptKey(account.tenantId)}" }`);
                if (rsaKey) {
                    var result2 = await axios.get(`${WEB_API_URL}User/GetUserByAzureTenantId`, {
                        params: {
                            key: `${rsaKey}`
                        }
                    });

                    if (result2.data != null) {
                        return result2.data;
                    }
                }
            }
        }
    }
    return "";
}


export async function searchForCompanyUsersByName(companyId, searchQuery) {

    var rsaKey = `{CompanyId: "${await encryptKey(companyId.toString())}", SearchQuery: "${await encryptKey(searchQuery)}" }`;

    if (rsaKey) {
        var result = await axios.get(`${WEB_API_URL}User/SearchForCompanyUsersByName`, {
            params: {
                key: `${rsaKey}`
            }
        });
        if (result.data != null) {
            return result.data;
        }
    }
}

export async function getAllCompanyUsers(companyId) {

    var rsaKey = `{CompanyId: "${await encryptKey(companyId.toString())}"}`;
    if (rsaKey) {
        var result = await axios.get(`${WEB_API_URL}User/GetAllCompanyUsers`, {
            params: {
                key: `${rsaKey}`
            }
        });

        if (result.data != null) {

            return result.data;
        }
    }
}

export async function getAllSystemUsers(sysAdminId) {

    var rsaKey = `{SysAdminId: "${await encryptKey(sysAdminId)}"}`;
    if (rsaKey) {
        var result = await axios.get(`${WEB_API_URL}AdminUtilities/GetAllSystemUsers`, {
            params: {
                key: `${rsaKey}`
            }
        });
        if (result.data != null) {
            return result.data;
        }
    }
}

export async function getCountOfTenantUsers(companyId, tenantId) {

    var rsaKey = `{CompanyId: "${await encryptKey(companyId.toString())}", TenantId: "${await encryptKey(tenantId.toString())}"}`;
    if (rsaKey) {
        var result = await axios.get(`${WEB_API_URL}AdminUtilities/GetCountOfTenantUsers`, {
            params: {
                key: `${rsaKey}`
            }
        });
        if (result.data != null) {
            return result.data;
        }
    }
}

export async function searchAuditVaultUsers(companyId, tenantId, emailQuery, roleId) {

    var rsaKey = `{CompanyId: "${await encryptKey(companyId.toString())}", TenantId: "${await encryptKey(tenantId.toString())}", EmailQuery: "${await encryptKey(emailQuery)}", RoleId: "${await encryptKey(roleId.toString())}"}`;
    if (rsaKey) {
        var result = await axios.get(`${WEB_API_URL}User/SearchAuditVaultUsers`, {
            params: {
                key: `${rsaKey}`
            }
        });
        if (result.data != null) {
            return result.data;
        }
    }
}

export async function getCompanyAdmins(companyId) {

    var rsaKey = `{CompanyId: "${await encryptKey(companyId.toString())}"}`;
    if (rsaKey) {
        var result = await axios.get(`${WEB_API_URL}User/GetCompanyAdmins`, {
            params: {
                key: `${rsaKey}`
            }
        });
        if (result.data != null) {
            return result.data;
        }
    }
}

export async function getTenantUsersByRole(tenantId, roleId) {

    var rsaKey = `{TenantId: "${await encryptKey(tenantId.toString())}", RoleId: "${await encryptKey(roleId.toString())}"}`;
    if (rsaKey) {
        var result = await axios.get(`${WEB_API_URL}User/GetTenantUsersByRole`, {
            params: {
                key: `${rsaKey}`
            }
        });
        if (result.data != null) {
            return result.data;
        }
    }
}

export async function getSystemAdmins(sysAdminId) {

    var rsaKey = `{SysAdminId: "${await encryptKey(sysAdminId)}"}`;
    if (rsaKey) {
        var result = await axios.get(`${WEB_API_URL}AdminUtilities/GetSystemAdmins`, {
            params: {
                key: `${rsaKey}`
            }
        });
        if (result.data != null) {
            return result.data;
        }
    }
}


export async function removeSystemAdminAccess(sysAdminId, removeSysAdminId) {

    var rsaKey = `{SysAdminId: "${await encryptKey(sysAdminId)}", RemoveSysAdminId: "${await encryptKey(removeSysAdminId)}" }`;
    if (rsaKey) {
        var result = await axios.put(`${WEB_API_URL}AdminUtilities/RemoveSystemAdminAccess`, null, {
            params: {
                key: rsaKey,
            }
        });
        if (result.data != null) {
            return result.data;
        }
    }
}

export async function linkSystemAdminToCompany(companyId, sysAdminId, setAsCompanyAdmin) {

    var rsaKey = `{CompanyId: "${await encryptKey(companyId)}", SysAdminId: "${await encryptKey(sysAdminId)}", SetAsCompanyAdmin: "${await encryptKey(setAsCompanyAdmin)}" }`;
    if (rsaKey) {
        var result = await axios.put(`${WEB_API_URL}AdminUtilities/LinkSystemAdminToCompany`, null, {
            params: {
                key: rsaKey,
            }
        });
        if (result.data != null) {
            return result.data;
        }
    }
}

export async function removeAuditVaultUserPermission(user, roleId, userRemovedFromRoleMicrosoftId) {

    var payload = `{ RoleId: ${roleId},`;
    payload = payload + `UserRemovedFromRoleMicrosoftId: "${await encryptKey(userRemovedFromRoleMicrosoftId)}",`;
    payload = payload + `UserMicrosoftId: "${await encryptKey(user.microsoftUserId)}"}`;
    if (payload) {
        var result = await axios.delete(`${WEB_API_URL}User/RemoveAuditVaultUserPermission`, {
            params: {
                key: `${payload}`
            }
        });

        if (result.data != null) {
            return result.data;
        }
    }
}


export function verifyUserCanAccessTenantData(user, tenantId) {
    if (user) {
        if (user.isSystemAdmin)
            return true;

        if (user.isCompanyAdmin)
            return true;

        if (user.isTenantAdmin)
            return true;

        if (user.isTenantReportReader)
            return true;

        if (user.isTenantViewer)
            return true;
    }
    return false;
}


export function verifyUserCanAccessCompanyData(user) {
    if (user) {
        if (user.isSystemAdmin) {
            return true;
        }

        if (user.isCompanyAdmin) {
            return true;
        }
    }
    return false;
}


// Function that checks the User's permissions and ensure they have an entry for the specific tenantId where the role <= roleId.
export function verifyUserHasTenantRolePermissions(user, roleId) {

    /*
        TenantReportReader = 3,
        TenantViewer = 4,
        LifeCycleCoordinator = 5,
        LifeCycleReviewer = 6,
        LifeCycleApprover = 7,
    */
    if (!user)
        return false;

    if (user.isSystemAdmin)
        return true;

    if (user.isCompanyAdmin)
        return true;

    if (user.isTenantAdmin)
        return true;

    switch (roleId) {
        case 3:
            if (user.isTenantReportReader)
                return true;

        case 4:
            if (user.isTenantReportReader || user.isTenantViewer)
                return true;
    }

    return false;
}


export function validateEmail(input) {

    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!input || regex.test(input) === false) {

        return false;
    }
    return true;
}


